export default __webpack_public_path__ + "8bce4a05b5683de9d8c317ce77ee796e.png";